import React from 'react'
import RouteController from '../RouteController'

const App = () => {
  return <RouteController />
}

export default App
